/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberFinancialDataResponseDto { 
    id?: number;
    userId?: number;
    creditUnionFinancialDataId?: number;
    memberName?: string | null;
    memberRefNo?: string | null;
    status?: string | null;
    loanAccFeededValue?: number;
    contributionAmount?: number;
    savingAccFeededValue?: number;
    shareAccFeededValue?: number;
    hasContributionDataMigrated?: boolean | null;
    hasCurrentDataMigrated?: boolean | null;
    hasLoanDataMigrated?: boolean | null;
    hasShareDataMigrated?: boolean | null;
    hasSavingDataMigrated?: boolean | null;
    hasVerified?: boolean;
    chargesAmount?: number;
    hasChargeDataMigrated?: boolean | null;
}

